/* kleren-stitching.js — Get It Stitched ADD-ON widget, v3.1 all-custom flow.
   Checking the box shows the measurement form instantly, pre-filled with size M.
   XS–XL chips quick-fill preset values; editing any field marks it "Customized".
   On ATC we first add the hidden Custom Stitching Service line via /cart/add.js,
   then re-fire the click so the native Kalles handler adds the dress (with all
   measurement properties) and renders the cart drawer itself.
   Fully event-delegated so it also works for DOM injected later (quick view). */
(function () {
  'use strict';
  if (window.__ksStitchInit) return;
  window.__ksStitchInit = true;

  var DEFAULT_PRESET = 'M';

  function widgetOf(el) { return el.closest('[data-ks-widget]'); }
  function formOf(widget) { return widget.closest('form'); }

  function presetsOf(widget) {
    if (!widget.__ksPresets) {
      try { widget.__ksPresets = JSON.parse(widget.getAttribute('data-ks-presets') || '{}'); }
      catch (e) { widget.__ksPresets = {}; }
    }
    return widget.__ksPresets;
  }

  function setSizeProperty(widget, value) {
    var inp = widget.querySelector('[data-ks-size-input]');
    if (inp) inp.value = value;
  }

  function markState(widget, preset, customized) {
    widget.__ksPreset = preset;
    widget.querySelectorAll('[data-ks-size]').forEach(function (p) {
      p.classList.toggle('is--active', !customized && p.getAttribute('data-ks-size') === preset);
    });
    var state = widget.querySelector('[data-ks-state]');
    if (state) state.hidden = !customized;
    setSizeProperty(widget, customized ? 'Customized (from ' + preset + ')' : preset + ' (preset)');
  }

  function applyPreset(widget, size) {
    var vals = presetsOf(widget)[size];
    if (!vals) return;
    widget.querySelectorAll('[data-ks-fields] input[name^="properties["]').forEach(function (inp) {
      if (inp.hasAttribute('data-ks-size-input')) return;
      var m = inp.name.match(/\[(.+)\]/);
      if (m && Object.prototype.hasOwnProperty.call(vals, m[1])) {
        inp.value = vals[m[1]];
        inp.classList.remove('ks-invalid');
      }
    });
    markState(widget, size, false);
    var err = widget.querySelector('[data-ks-error]');
    if (err) err.hidden = true;
  }

  function setChecked(widget, on) {
    var body = widget.querySelector('[data-ks-body]');
    var sizeInp = widget.querySelector('[data-ks-size-input]');
    var fields = widget.querySelector('[data-ks-fields]');
    var form = formOf(widget);
    if (body) body.hidden = !on;
    if (sizeInp) sizeInp.disabled = !on;
    if (fields) fields.disabled = !on; /* disabled fieldset = properties not submitted */
    if (form) form.classList.toggle('ks-checked', on); /* CSS hides Buy-It-Now */
    markType(widget, on);
    if (on && !widget.__ksPreset) applyPreset(widget, DEFAULT_PRESET);
  }

  /* Paint the Unstitched/Stitched chips + fee line. Lives here so any
     programmatic setChecked (reset, re-render) stays visually correct. */
  function markType(widget, on) {
    widget.querySelectorAll('[data-ks-type-btn]').forEach(function (b) {
      var sel = (b.getAttribute('data-ks-type-btn') === 'stitched') === !!on;
      b.classList.toggle('is--active', sel);
      b.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    var fee = widget.querySelector('[data-ks-fee]');
    if (fee) fee.hidden = !on;
  }

  function validate(widget) {
    var ok = true, first = null;
    widget.querySelectorAll('[data-ks-req]').forEach(function (inp) {
      var v = parseFloat(String(inp.value).replace(/[^0-9.]/g, ''));
      var bad = !(v >= 4 && v <= 100);
      inp.classList.toggle('ks-invalid', bad);
      if (bad) { ok = false; if (!first) first = inp; }
    });
    var err = widget.querySelector('[data-ks-error]');
    if (err) {
      if (!ok) err.textContent = 'Please fill the required measurements marked * (numbers in inches).';
      err.hidden = ok;
    }
    if (!ok && first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { first.focus({ preventScroll: true }); } catch (e) { }
    }
    return ok;
  }

  /* Strip empty optional inputs for a moment so they don't reach the cart as blank props. */
  function suppressEmptyOptionals(widget) {
    var restore = [];
    widget.querySelectorAll('[data-ks-fields] input, [data-ks-fields] textarea').forEach(function (inp) {
      if (!inp.hasAttribute('data-ks-req') && !inp.hasAttribute('data-ks-size-input') && String(inp.value).trim() === '') {
        inp.disabled = true;
        restore.push(inp);
      }
    });
    setTimeout(function () { restore.forEach(function (inp) { inp.disabled = false; }); }, 2500);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-ks-toggle]')) return;
    var widget = widgetOf(t);
    if (widget) setChecked(widget, t.checked);
  });

  /* Unstitched / Stitched chips drive the hidden checkbox, which re-enters the
     change listener above — so every downstream path is unchanged. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ks-type-btn]');
    if (!btn) return;
    e.preventDefault();
    var widget = widgetOf(btn);
    if (!widget) return;
    var toggle = widget.querySelector('[data-ks-toggle]');
    if (!toggle) return;
    var want = btn.getAttribute('data-ks-type-btn') === 'stitched';
    if (toggle.checked === want) { markType(widget, want); return; } /* re-tap: just resync paint */
    toggle.checked = want;
    toggle.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Preset chips fill the form. */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-ks-size]');
    if (!pill) return;
    var widget = widgetOf(pill);
    if (widget) applyPreset(widget, pill.getAttribute('data-ks-size'));
  });

  /* Any manual edit switches the order to Customized (chips clear; re-click to reset). */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-ks-fields] input, [data-ks-fields] textarea')) return;
    if (t.hasAttribute('data-ks-size-input') || t.matches('textarea')) return;
    var widget = widgetOf(t);
    if (widget && widget.__ksPreset) markState(widget, widget.__ksPreset, true);
  });

  /* Kalles adds to cart via AJAX on button CLICK (no submit event) — intercept in
     capture phase: add the service line first, then re-fire the click for Kalles. */
  function guard(e, widget, btn) {
    var toggle = widget.querySelector('[data-ks-toggle]');
    if (!toggle || !toggle.checked) return; /* plain unstitched add — let Kalles run */

    if (widget.__ksPassthrough) { widget.__ksPassthrough = false; return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (widget.__ksBusy) return;
    if (!validate(widget)) return;

    var form = formOf(widget);
    var qtyInp = form && form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInp && qtyInp.value, 10) || 1);

    widget.__ksBusy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(widget.getAttribute('data-ks-service-id'), 10),
          quantity: qty,
          properties: {
            'Article': widget.getAttribute('data-ks-article') || '',
            '_ks_for': widget.getAttribute('data-ks-dress-id') || ''
          }
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('service add failed ' + r.status);
      return r.json();
    }).then(function () {
      suppressEmptyOptionals(widget);
      widget.__ksBusy = false;
      widget.__ksPassthrough = true;
      btn.click(); /* Kalles now adds the dress + renders the drawer */
    }).catch(function (err) {
      widget.__ksBusy = false;
      console.error('[ks-stitching]', err);
      var errEl = widget.querySelector('[data-ks-error]');
      if (errEl) {
        errEl.textContent = 'Could not add stitching — please try again.';
        errEl.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], [data-atc-form]');
    if (!btn) return;
    var form = btn.closest('form[data-type="add-to-cart-form"]');
    var widget = form && form.querySelector('[data-ks-widget]');
    if (widget) guard(e, widget, btn);
  }, true);

  /* Fallback for non-AJAX submits. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var widget = form.querySelector('[data-ks-widget]');
    var btn = form.querySelector('button[name="add"]');
    if (widget && btn) guard(e, widget, btn);
  }, true);

  /* ---- Cart guard: keep service lines paired with their dress lines. ----
     Service lines carry _ks_for = dress variant id. If the dress is gone,
     remove the orphan service line; if quantities drifted, resync. */
  var guardBusy = false;
  function cartGuard() {
    if (guardBusy) return;
    guardBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var changes = [];
        cart.items.forEach(function (item) {
          var forId = item.properties && item.properties._ks_for;
          if (!forId) return;
          var dressQty = 0;
          cart.items.forEach(function (d) {
            if (String(d.variant_id) === String(forId) && d.properties && d.properties['Stitching Size']) {
              dressQty += d.quantity;
            }
          });
          if (item.quantity !== dressQty) {
            changes.push({ id: item.key, quantity: dressQty }); /* 0 removes orphan */
          }
        });
        var run = Promise.resolve();
        changes.forEach(function (ch) {
          run = run.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(ch)
            });
          });
        });
        return run.then(function () {
          if (changes.length && window.location.pathname === '/cart') window.location.reload();
        });
      })
      .catch(function () { })
      .finally(function () { guardBusy = false; });
  }

  /* Run the guard after cart interactions (remove buttons, qty steppers) settle. */
  var guardTimer = null;
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-cart-remove], [data-quantity-selector], .t4s-mini_cart__actions, form[action*="/cart"], [href*="/cart/change"]')) {
      clearTimeout(guardTimer);
      guardTimer = setTimeout(cartGuard, 1500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { if (location.pathname === '/cart') cartGuard(); });
  } else {
    if (location.pathname === '/cart') cartGuard();
  }
})();
